module.exports = __webpack_public_path__ + "static/media/J.004954a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/J.jpg
// module id = 78
// module chunks = 0